export const selectMainShippingAddress = (addresses = []) => {
    if (!Array.isArray(addresses)) return null;
    return (
        addresses.find((address) => address?.is_main) ||
        addresses.find((address) => address?.is_primary) ||
        null
    );
};

export const resolveMainAddressUpsertMode = (addresses = []) => {
    const mainAddress = selectMainShippingAddress(addresses);
    if (mainAddress?.address_id) {
        return { mode: "update", addressId: mainAddress.address_id };
    }
    return { mode: "create", addressId: null };
};
